import { render, staticRenderFns } from "./NotifyCard.vue?vue&type=template&id=e70115dc&scoped=true&"
import script from "./NotifyCard.vue?vue&type=script&lang=js&"
export * from "./NotifyCard.vue?vue&type=script&lang=js&"
import style0 from "./NotifyCard.vue?vue&type=style&index=0&id=e70115dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70115dc",
  null
  
)

export default component.exports